import { Component, OnDestroy, Inject, OnInit, Input } from '@angular/core';

interface IFieldChangeModalContext {
  data: any;
  title?: string;
}
@Component({
  selector: 'app-field-registration-details-verify-cac',
  templateUrl: './cac-record.html',
  styleUrls: ['./cac-record.scss'],
})
export class RegistrationDetailsCACVerifyModalComponent {
  @Input() companies;
  @Input() type;
  @Input() org;
  @Input() tinNumber;
  @Input() pending;
}
